// 封装所以和用户相关的接口函数
import request from '@/utils/http'
const AUTH_BASE_URL = "/api/v1";
/**
 * 钱庄列表
 * @param {} params 
 * @returns 
 */
export const getBankListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/bank_list`,
        params
    })
}
/**
 * 钱庄订单列表
 */

export const getBankOrderListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/bank_order_list`,
        params
    })
}
/**
 * 创建订单
 */


export const getCreateBankOrderAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/create_bank_order`,
        method: 'POST',
        data
    })
}
/**
 * 订单处理
 * @param {} params 
 * @returns 
 */
export const getModifyBankOrderAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/modify_bank_order`,
        method: 'POST',
        data
    })
}

/**
 * 详情
 */
export const getOrderDetailAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/bank_order_detail`,
        method: 'POST',
        data
    })
}
//取消充值
export const setCancelBankAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/cancel_bank_order`,
        method: 'POST',
        data
    })
}
/**
 * 提现
 */

export const setWithdrawAPI = (data) => {
    return request({
        url: `${AUTH_BASE_URL}/apply_withdraw`,
        method: 'POST',
        data
    })
}
/**
 * 提现列表
 */

export const getWithdrawListAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/withdraw_list`,
        params
    })
}


/**
 * 获取配置
 * @param {*} params 
 * @returns 
 */
export const getConfigAPI = (params) => {
    return request({
        url: `${AUTH_BASE_URL}/config`,
        method: 'GET',
        params
    })
}
/**
 * 获取汇率
 */
export const getExchangeRateAPI= () => {
    return request({
        url: `${AUTH_BASE_URL}/withDrawRate`,
        method: 'GET'
    })
}

/**
 * 获取返利记录
 */

export const getRebatesLogsAPI= (params) => {
    return request({
        url: `${AUTH_BASE_URL}/user_rebates_logs`,
        method: 'GET',
        params
    })
}
/**
 * 获取返利记录
 */

export const getrRewardListAPI= (params) => {
    return request({
        url: `${AUTH_BASE_URL}/promoter/reward_list`,
        method: 'GET',
        params
    })
}